import { RoomLabel } from './roomLabel.model';
import { Address } from './address.model';
import { Price } from './price.model';

export interface Room {
  address: Address;
  centreName: string;
  centreNumber: number;
  distanceValue?: number;
  enquiryCount: number;
  isBestValue?: boolean;
  isClicked?: boolean;
  isHighDemand: boolean;
  isHovered?: boolean;
  isPrestige?: boolean;
  isUnavailable?: boolean;
  isWebBookable: boolean;
  labels: RoomLabel;
  mainPhotoUrl: string;
  phoneNumber?: string;
  price: Price;
}

export enum RoomType {
  INITIAL,
  AVAILABLE,
  UNAVAILABLE
}
